module.exports = __webpack_public_path__ + "img/backyard-bushes.b1d26bc9.webp";